const headerOptions = [
  { title: "S No." },
  { title: "Name" },
  { title: "Action" }
];

const groupListHeadersOptions = [
  { title: "S No." },
  { title: "Name" },
  { title: "Parent Name" },
  { title: "Action" }
];

const userListHeaderOptions = [
  { title: "S No." },
  { title: "Name" },
  { title: "Organization/Group" },
  { title: "Active" },
  { title: "Action" }
];

const bestPracticesHeader = [
  { title: "Ministry" },
  { title: "Topic" },
  { title: "Description" },
  { title: "Added On" },
  { title: "Action" }
];

export {
  headerOptions,
  userListHeaderOptions,
  groupListHeadersOptions,
  bestPracticesHeader
};
